import { render, staticRenderFns } from "./AssignmentDetails.vue?vue&type=template&id=b45d1d8a&scoped=true"
import script from "./AssignmentDetails.vue?vue&type=script&lang=ts"
export * from "./AssignmentDetails.vue?vue&type=script&lang=ts"
import style0 from "./AssignmentDetails.vue?vue&type=style&index=0&id=b45d1d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45d1d8a",
  null
  
)

export default component.exports